
export default {
  filters: {
    ceil (num) {
      const numb = Math.round((num + Number.EPSILON) * 100) / 100
      return Math.ceil(numb)
    }
  }
}
